export default __webpack_public_path__ + "static/media/20230404_165505.5c175fe9.jpg";